import React, { useState } from "react";
import { useUserInfo } from "../../../context/user";
import { useNavigate, useLocation } from "react-router-dom";
import YoureAllSet from "./YoureAllSet"; // ✅ adjust the path if different
import { Toast } from "../../../components/Toast/Toast";
import { useConfigureAIWeb, useCheckSaasPlan } from "../../../queries/onboarding";

const ConfigureYourAIWeb = ({ setBusinessType, setSuccess, HandleEveryStep }) => {
  const [loading, setLoading] = useState(false);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const { mutateAsync: configureAIWeb } = useConfigureAIWeb();
  const { mutateAsync: checkSaasPlan } = useCheckSaasPlan();
  const [inputError, setInputError] = useState("");
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("error");
  const [toastMessage, setToastMessage] = useState("");
  const [toastSubMessage, setToastSubMessage] = useState("");
  const [isAnimationCompleted, setIsAnimationCompleted] = useState(false);

  const location = useLocation();
  const { accountDataLocation } = location.state || {};

  console.log("Account ID from navigation:", accountDataLocation);

  const [
    userInfo,
    ,
    ,
    // user, Update, clear
    setUserActiveLocation,
    userActiveLocation,
    saveActiveLocation, // ⬅️ we’ll reuse the existing helper
  ] = useUserInfo();

  const navigate = useNavigate();

  const isValidUrl = (value) => {
    const trimmed = (value || "").trim();
    if (!trimmed) return false;
    // Accepts domains with or without an http(s):// prefix, e.g. example.com or https://example.com/path
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;
    return urlPattern.test(trimmed);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedUrl = (websiteUrl || "").trim();

    if (!isValidUrl(trimmedUrl)) {
      setInputError("This URL is invalid. Please check the address and try again.");
      return;
    }
    setInputError("");
    setWebsiteUrl(trimmedUrl);

    setLoading(true);
    setIsAnimationCompleted(true);
    setSuccess(true)

    const profileId = accountDataLocation
      ? accountDataLocation
      : userActiveLocation?.id;

    try {
      const response = await configureAIWeb({
        onboardingPayload: {
          website_url: trimmedUrl,
          profileId,
          username: userActiveLocation?.business_name || userActiveLocation?.first_name,
        },
        accountsPayload: {
          onboarding: {
            ...userActiveLocation?.onboarding,
            website_url: trimmedUrl,
            email: userInfo.email,
            verified:
              userInfo?.verified === undefined ? true : userInfo.verified,
          },
          _id: profileId,
        },
      });

      if (response?.success) {
        HandleEveryStep(5);
        await saveActiveLocation(response.data)
        setUserActiveLocation(response.data);
        setToastMessage(null);
        setLoading(false);
      }
    } catch (error) {
      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        "";
      const isNetworkError =
        error.code === "ERR_NETWORK" ||
        error.message === "Network Error" ||
        !error.response ||
        /ENOTFOUND|getaddrinfo|ECONNREFUSED|ETIMEDOUT|EAI_AGAIN/i.test(
          backendMessage
        );

      if (isNetworkError) {
        setToastType("error");
        setToastMessage("We’re having trouble connecting.");
        setToastSubMessage(
          "Please check your internet connection and try again."
        );
        setToastVisible(true);
      } else if (
        error.response?.data?.error?.err ===
        "Bad request, domain is not reachable"
      ) {
        setToastType("error");
        setToastMessage("The website address you entered could not be reached");
        setToastSubMessage(
          "Please ensure that you have provided a valid and accessible URL"
        );
        setToastVisible(true);
      } else if (
        error.response?.data?.error?.error ===
        "Bad request, no abstract generated"
      ) {
        setToastType("error");
        setToastMessage(
          "The website you entered does not contain enough information to process"
        );
        setToastSubMessage(
          "Please upload a brochure, presentation or sales document instead."
        );
        setToastVisible(true);
      } else {
        const exactError =
          error.response?.data?.error?.err ||
          error.response?.data?.error?.error ||
          (typeof error.response?.data?.error === "string"
            ? error.response.data.error
            : "") ||
          backendMessage ||
          error.message;
        setToastType("error");
        setToastMessage("Onboarding failed. Please try again later.");
        setToastSubMessage(exactError || "Unexpected error occurred");
        setToastVisible(true);
      }
      setLoading(false);
    }
  };

  if (isAnimationCompleted) {
    return (
      <YoureAllSet
        success={loading}
        onComplete={async () => {
          if (!toastMessage && !loading) {
            // Check if payment is required before navigating
            if (userActiveLocation?.type === "premium" && !userActiveLocation?.subscription_id) {
              try {
                const resp = await checkSaasPlan();
                if (!resp?.data?.is_free_saas) {
                  navigate("/auth/add-payment");
                  return;
                }
              } catch (e) {
                console.error("Error checking plan:", e);
              }
            }
            navigate("/app/chat")
          } else {
            setIsAnimationCompleted(false)
          }
        }}
      />
    );
  }

  return (
    <div className="!bg-background">
      <div className="container-main !w-[430px] bg-background">
        <div className="container pb-10 bg-background">
          <div className="text-center">
            <h1 className="text-[30px] font-medium text-foreground">Configure Your AI</h1>
            <p
              className={`mt-4 ${toastMessage ? "text-destructive" : "text-foreground"
                }`}
            >
              {toastMessage && toastMessage + " " + toastSubMessage}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="loginForm w-[380px] mt-10">
            <div className="mb-2">
              <input
                type="text"
                name="website_url"
                placeholder="Website URL"
                value={websiteUrl}
                onChange={(e) => setWebsiteUrl(e.target.value)}
                className="w-full"
                autoComplete="off"
              />
              {inputError && (
                <p className="text-red-500 text-start text-sm mt-1">
                  {inputError}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || !websiteUrl}
              style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
              className={`${loading || !websiteUrl
                ? "!bg-muted border !border-border !text-muted-foreground"
                : "bg-foreground text-background hover:bg-foreground/90 transition-colors"
                } mt-5`}
            >
              {loading ? "Loading..." : "Let\u2019s go!"}
            </button>
          </form>
        </div>

        <span
          onClick={() => setBusinessType(null)}
          className="text-muted-foreground text-[12px] ml-8 cursor-pointer"
        >
          ← Go back
        </span>
      </div>

      <Toast
        type={toastType}
        message={toastMessage}
        subMessage={toastSubMessage}
        visible={toastVisible}
        onClose={() => setToastVisible(false)}
      />
    </div>
  );
};

export default ConfigureYourAIWeb;
